import { z } from "zod";
import { PublicIdSchema } from "./common";

/**
 * driver アプリ (LIFF) からの GPS 現在地報告。配車リアルタイム配信 (F10) 用。
 *
 * 送信トリガは距離ベース (前回送信地点から 100m 超移動) で、停車中は送らない (バッテリ配慮)。
 * 緯度経度は数値。recorded_at は端末の計測時刻 (ISO8601, offset 付き)。
 */
export const ReportLocationInput = z.object({
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  heading: z.number().min(0).max(360).optional(),
  speed_kmh: z.number().nonnegative().optional(),
  accuracy_m: z.number().nonnegative().optional(),
  recorded_at: z.iso.datetime({ offset: true }),
});

export const ReportLocationOutput = z.object({
  recorded_at: z.iso.datetime({ offset: true }),
});

export type ReportLocationInputDto = z.infer<typeof ReportLocationInput>;
export type ReportLocationOutputDto = z.infer<typeof ReportLocationOutput>;

/**
 * ドライバーごとの最終観測位置 (Issue #503)。admin のドライバー状況画面が
 * 画面オープン時のスナップショット表示に使う。ライブ更新は FleetHub WS が担い、
 * これは「最後に観測した位置」の初期値。driver_locations は 24h TTL のため
 * それより古い位置は返らない。内部 id は露出しない (driver_id は public_id)。
 */
export const DriverLatestLocation = z.object({
  driver_id: PublicIdSchema,
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  recorded_at: z.iso.datetime({ offset: true }),
});

export type DriverLatestLocationDto = z.infer<typeof DriverLatestLocation>;
